'use strict';

var _toConsumableArray = require("/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/stefan/coding/politik-jam/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var enUs = _interopDefault(require('hyphenated-en-us'));

var PatternTrie = /*#__PURE__*/function () {
  function PatternTrie() {
    _classCallCheck(this, PatternTrie);

    this.tree = {};
  }

  _createClass(PatternTrie, [{
    key: "insert",
    value: function insert(chars, points) {
      var subTree = this.tree;

      var _iterator = _createForOfIteratorHelper(chars),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (!subTree[char]) {
            subTree[char] = {};
          }

          subTree = subTree[char];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      subTree[null] = points;
    }
  }, {
    key: "getPoints",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function getPoints(chars) {
      var subTree, _iterator2, _step2, char;

      return _regeneratorRuntime.wrap(function getPoints$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subTree = this.tree;
              _iterator2 = _createForOfIteratorHelper(chars);
              _context.prev = 2;

              _iterator2.s();

            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 16;
                break;
              }

              char = _step2.value;
              subTree = subTree[char];

              if (!subTree) {
                _context.next = 13;
                break;
              }

              if (!subTree[null]) {
                _context.next = 11;
                break;
              }

              _context.next = 11;
              return subTree[null];

            case 11:
              _context.next = 14;
              break;

            case 13:
              return _context.abrupt("break", 16);

            case 14:
              _context.next = 4;
              break;

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](2);

              _iterator2.e(_context.t0);

            case 21:
              _context.prev = 21;

              _iterator2.f();

              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, getPoints, this, [[2, 18, 21, 24]]);
    })
  }]);

  return PatternTrie;
}();

var defaults = {
  joiner: "\xAD",
  borderMarker: '.',
  minWordLength: 4
};

var decodePattern = function decodePattern(pattern) {
  return {
    chars: pattern.replace(/[0-9]/g, ''),
    points: pattern.split(/(?:[\0- '\x2D\.A-Za-z\x7F-\xA0\xAA\xAD\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376-\u037D\u037F-\u0383\u0386\u0388-\u03F5\u03F7-\u0481\u0483-\u0559\u0560-\u0588\u058B\u058C\u0590-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7-\u05F2\u05F5-\u0605\u0610-\u061A\u061C\u061D\u0620-\u065F\u066E-\u06D3\u06D5-\u06DD\u06DF-\u06E8\u06EA-\u06EF\u06FA-\u06FC\u06FF\u070E-\u07BF\u07CA-\u07F5\u07FA-\u07FD\u0800-\u082F\u083F-\u085D\u085F-\u0963\u0971-\u09E5\u09F0\u09F1\u09FC\u09FE-\u0A65\u0A70-\u0A75\u0A77-\u0AE5\u0AF2-\u0B65\u0B71\u0B78-\u0BE5\u0BFB-\u0C65\u0C70-\u0C76\u0C80-\u0C83\u0C85-\u0CE5\u0CF0-\u0D4E\u0D50-\u0D57\u0D5F-\u0D65\u0D7A-\u0DE5\u0DF0-\u0DF3\u0DF5-\u0E3E\u0E40-\u0E4E\u0E5C-\u0ECF\u0EDA-\u0F00\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E-\u0F84\u0F86-\u0FBD\u0FC6\u0FCD\u0FDB-\u103F\u1050-\u108F\u109A-\u109D\u10A0-\u10FA\u10FC-\u135F\u137D-\u138F\u139A-\u13FF\u1401-\u166C\u166F-\u169A\u169D-\u16EA\u16F1-\u1734\u1737-\u17D3\u17D7\u17DC-\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180B-\u180F\u181A-\u193F\u1941-\u1943\u1950-\u19CF\u19DB-\u19DD\u1A00-\u1A1D\u1A20-\u1A7F\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AA7\u1AAE-\u1B4F\u1B6B-\u1B73\u1B7D-\u1BAF\u1BBA-\u1BFB\u1C00-\u1C3A\u1C4A-\u1C4F\u1C5A-\u1C7D\u1C80-\u1CBF\u1CC8-\u1CD2\u1CD4-\u1FBC\u1FBE\u1FBF\u1FC2-\u1FCC\u1FD0-\u1FDC\u1FE0-\u1FEC\u1FF0-\u1FFC\u1FFF-\u200F\u2028-\u202F\u205F-\u206F\u2071-\u2073\u207F\u208F-\u209F\u20C0-\u20FF\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2C00-\u2CE4\u2CEB-\u2CF8\u2D00-\u2D6F\u2D71-\u2DFF\u2E2F\u2E50-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u3000\u3005\u3006\u302A-\u302F\u3031-\u3035\u303B\u303C\u3040-\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u318F\u31A0-\u31BF\u31E4-\u31FF\u321F\u32FF\u3400-\u4DBF\u4E00-\uA48F\uA4C7-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A-\uA672\uA674-\uA67D\uA67F-\uA6E5\uA6F0\uA6F1\uA6F8-\uA6FF\uA717-\uA71F\uA722-\uA788\uA78B-\uA827\uA82C-\uA82F\uA83A-\uA873\uA878-\uA8CD\uA8DA-\uA8F7\uA8FB\uA8FD-\uA8FF\uA90A-\uA92D\uA930-\uA95E\uA960-\uA9C0\uA9CE\uA9CF\uA9DA-\uA9DD\uA9E0-\uA9EF\uA9FA-\uAA4F\uAA5A\uAA5B\uAA60-\uAA76\uAA7A-\uAADD\uAAE0-\uAAEF\uAAF2-\uAB5A\uAB5C-\uABEA\uABEC-\uABEF\uABFA-\uD7FF\uE000-\uFB28\uFB2A-\uFBB1\uFBC2-\uFD3D\uFD40-\uFDFB\uFDFE-\uFE0F\uFE1A-\uFE2F\uFE53\uFE67\uFE6C-\uFF00\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]|\uD800[\uDC00-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFD-\uDEE0\uDEFC-\uDF1F\uDF24-\uDF40\uDF42-\uDF49\uDF4B-\uDF9E\uDFA0-\uDFCF\uDFD6-\uDFFF]|\uD801[\uDC00-\uDC9F\uDCAA-\uDD6E\uDD70-\uDFFF]|\uD802[\uDC00-\uDC56\uDC60-\uDC76\uDC80-\uDCA6\uDCB0-\uDCFA\uDD00-\uDD15\uDD1C-\uDD1E\uDD20-\uDD3E\uDD40-\uDDBB\uDDBE\uDDBF\uDDD0\uDDD1\uDE00-\uDE3F\uDE49-\uDE4F\uDE59-\uDE7C\uDE80-\uDE9C\uDEA0-\uDEC7\uDEC9-\uDEEA\uDEF7-\uDF38\uDF40-\uDF57\uDF60-\uDF77\uDF80-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC00-\uDCF9\uDD00-\uDD2F\uDD3A-\uDE5F\uDE7F-\uDF1C\uDF27-\uDF50\uDF5A-\uDFFF]|\uD804[\uDC00-\uDC46\uDC4E-\uDC51\uDC70-\uDCBA\uDCBD\uDCC2-\uDCEF\uDCFA-\uDD35\uDD44-\uDD73\uDD76-\uDDC4\uDDC9-\uDDCC\uDDCE\uDDCF\uDDDA\uDDDC\uDDE0\uDDF5-\uDE37\uDE3E-\uDEA8\uDEAA-\uDEEF\uDEFA-\uDFFF]|\uD805[\uDC00-\uDC4A\uDC5A\uDC5C\uDC5E-\uDCC5\uDCC7-\uDCCF\uDCDA-\uDDC0\uDDD8-\uDE40\uDE44-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDEBF\uDECA-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC3A\uDC3C-\uDCDF\uDCF3-\uDDE1\uDDE3-\uDE3E\uDE47-\uDE99\uDE9D\uDEA3-\uDFFF]|\uD807[\uDC00-\uDC40\uDC46-\uDC4F\uDC6D-\uDC6F\uDC72-\uDD4F\uDD5A-\uDD9F\uDDAA-\uDEF6\uDEF9-\uDFBF\uDFF2-\uDFFE]|[\uD808\uD80A-\uD819\uD81C-\uD82E\uD830-\uD833\uD837\uD839\uD83F-\uDBFF][\uDC00-\uDFFF]|\uD809[\uDC6F\uDC75-\uDFFF]|\uD81A[\uDC00-\uDE5F\uDE6A-\uDE6D\uDE70-\uDEF4\uDEF6-\uDF36\uDF40-\uDF43\uDF46-\uDF4F\uDF5A\uDF62-\uDFFF]|\uD81B[\uDC00-\uDE7F\uDE9B-\uDFE1\uDFE3-\uDFFF]|\uD82F[\uDC00-\uDC9B\uDC9D\uDC9E\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD65-\uDD69\uDD6D-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDDE9-\uDDFF\uDE42-\uDE44\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC00-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCD]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE8C-\uDFFF]|\uD838[\uDC00-\uDD3F\uDD4A-\uDD4E\uDD50-\uDEEF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD83A[\uDC00-\uDCC6\uDCD0-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD6D-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED6-\uDEDF\uDEED-\uDEEF\uDEFB-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C\uDD72\uDD77-\uDD79\uDDA3\uDDA4\uDDAB-\uDDAD\uDDCB\uDDCC\uDE54-\uDE5F\uDE6E\uDE6F\uDE74-\uDE77\uDE7B-\uDE7F\uDE83-\uDE8F\uDE96-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/).map(function (x) {
      return parseInt(x || 0);
    })
  };
};

var hyphenateException = function hyphenateException(exception) {
  return {
    key: exception.replace(/\-/g, ''),
    value: exception.replace(/\-/g, defaults.joiner)
  };
};

var whiteSpaceRegex = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|\x85/;
var separatorRegex = /(?!['@_])(?:[\t-\r -#%-\*,-\/:;\?@\[-\]_\{\}\xA0\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u3000-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFEFF\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F])/;

var getSpacesAndFragments = function getSpacesAndFragments(text) {
  var fragments = [];
  var fragment = '';
  var space = '';

  var addFragment = function addFragment() {
    if (fragment.length > 0) {
      fragments.push(fragment);
      fragment = '';
    }
  };

  var addSpace = function addSpace() {
    if (space.length > 0) {
      fragments.push(space);
      space = '';
    }
  };

  for (var charIndex = 0; charIndex < text.length; charIndex++) {
    var char = text.charAt(charIndex);

    if (whiteSpaceRegex.test(char)) {
      addFragment();
      space += char;
    } else {
      addSpace();
      fragment += char;
    }
  }

  addFragment();
  addSpace();
  return fragments;
};

var getWordsAndCharacters = function getWordsAndCharacters(fragment) {
  var wordStartIndex = null;
  var charIndex;
  var words = [];

  var addCharacter = function addCharacter(char) {
    return words.push(char);
  };

  var addWord = function addWord(characterIndex) {
    if (wordStartIndex !== null) {
      var word = fragment.slice(wordStartIndex, characterIndex);
      wordStartIndex = null;
      words.push(word);
    }
  };

  for (charIndex = 0; charIndex < fragment.length; charIndex++) {
    var char = fragment.charAt(charIndex);
    var isSeparator = separatorRegex.test(char);

    if (isSeparator) {
      addWord(charIndex);
      addCharacter(char);
    } else {
      if (wordStartIndex === null) {
        wordStartIndex = charIndex;
      }
    }
  }

  addWord(fragment.length);
  return words;
};

var parseText = function parseText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var allFragments = [];
  var spacesAndFragments = getSpacesAndFragments(text);

  if (spacesAndFragments.length) {
    var isSpace = whiteSpaceRegex.test(spacesAndFragments[0]);

    var _iterator3 = _createForOfIteratorHelper(spacesAndFragments),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var fragment = _step3.value;

        if (isSpace) {
          allFragments.push(fragment);
        } else {
          var wordsAndCharacters = getWordsAndCharacters(fragment);
          allFragments.push.apply(allFragments, _toConsumableArray(wordsAndCharacters));
        }

        isSpace = !isSpace;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return allFragments;
};

var isHyphenationPoint = function isHyphenationPoint(point) {
  return point % 2 === 1;
};

var hyphenateByPoints = function hyphenateByPoints(word) {
  var points = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hyphenated = '';

  for (var i = 0; i < word.length; i++) {
    hyphenated += (isHyphenationPoint(points[i]) ? defaults.joiner : '') + word.charAt(i);
  }

  return hyphenated;
};

var marker = defaults.borderMarker;

var hyphenateWord = function hyphenateWord(word, patternTrie) {
  var pattern = marker + word.toLocaleLowerCase() + marker;
  var patternPoints = new Array(pattern.length + 1).fill(0);

  for (var i = 0; i < pattern.length; i++) {
    var fragment = pattern.slice(i);

    var _iterator4 = _createForOfIteratorHelper(patternTrie.getPoints(fragment)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var fragmentPoints = _step4.value;

        for (var j = 0; j < fragmentPoints.length; j++) {
          patternPoints[i + j] = Math.max(patternPoints[i + j], fragmentPoints[j]);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } // drop the first and the last point (which correspond to the markers)
  // and then replace first two and last two points with zeros:


  var points = [0, 0].concat(_toConsumableArray(patternPoints.slice(3, patternPoints.length - 3)), [0, 0]);
  return hyphenateByPoints(word, points);
};

var createHyphenator = function createHyphenator(_ref) {
  var _ref$patterns = _ref.patterns,
      patterns = _ref$patterns === void 0 ? [] : _ref$patterns,
      _ref$exceptions = _ref.exceptions,
      exceptions = _ref$exceptions === void 0 ? [] : _ref$exceptions;
  var hyphenatedWords = {};
  var patternTrie = new PatternTrie();

  var _iterator5 = _createForOfIteratorHelper(patterns),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var pattern = _step5.value;

      var _decodePattern = decodePattern(pattern),
          chars = _decodePattern.chars,
          points = _decodePattern.points;

      patternTrie.insert(chars, points);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var _iterator6 = _createForOfIteratorHelper(exceptions),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var exception = _step6.value;

      var _hyphenateException = hyphenateException(exception),
          key = _hyphenateException.key,
          value = _hyphenateException.value;

      hyphenatedWords[key] = value;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return function (text) {
    return parseText(text).map(function (fragment) {
      var shouldHyphenate = fragment.length > defaults.minWordLength;

      if (shouldHyphenate) {
        if (!hyphenatedWords[fragment]) {
          var hyphenatedWord = hyphenateWord(fragment, patternTrie);
          hyphenatedWords[fragment] = hyphenatedWord;
        }

        return hyphenatedWords[fragment];
      }

      return fragment;
    }).join('');
  };
};

var createHyphenators = {};
var hyphenators = {
  get: function get() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : enUs;

    if (!createHyphenators[language.id]) {
      createHyphenators[language.id] = createHyphenator(language);
    }

    return createHyphenators[language.id];
  }
};

var hyphenated = function hyphenated(text) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      language = _ref2.language;

  return hyphenators.get(language)(text);
};

exports.hyphenated = hyphenated;